export default "__VITE_ASSET__b81a9128__"